import { Component, Input, OnInit, } from '@angular/core';

import { Label } from '@core/objects/label';

@Component({
    selector: 'core-label',
    templateUrl: './label.component.html',
    styleUrls: ['./label.component.scss'],
    providers: []
})
export class LabelComponent implements OnInit{
    @Input() label: Label;
    @Input() hoverable: Label;

    public isHover: boolean = false;
    public color: any;

    constructor(){}

    ngOnInit(): void {
        this.color = this.hexToRgb(this.label.group.color);
        // console.log(" COLOR ",this.color)
    }

    // only toggle hover when hoverable is set
    toggleHover(hov: boolean){
        if(!this.hoverable)
            return;
        this.isHover = hov;
    }

    hexToRgb(hex) {
        var result = (/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i).exec(hex);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null;
      }


}
